export class WavePlayer {
    width: string;
    height: string;
    iframeUrl: string;

    constructor(private $sce: ng.ISCEService, private $scope: ng.IScope) {
        const videoId = $scope.WavePlayer.id;
        this.width = $scope.WavePlayer.width || '100%';
        this.height = $scope.WavePlayer.height || '100%';

        this.iframeUrl = $sce.trustAsResourceUrl(
            `https://embed.wave.video/${videoId}`
        );
    }
}

angular.module('animatronApp.wavePlayer', []).component('wavePlayer', {
    controller: WavePlayer,
    controllerAs: 'WavePlayer',
    bindings: {
        id: '<',
        width: '<',
        height: '<'
    },
    template: `
    <div class="wave-player-container" style="padding: 56.25% 0 0 0; position: relative">
        <div style="height:100%;left:0;position:absolute;top:0;width:100%">
            <iframe src="{{::WavePlayer.iframeUrl}}" height="{{::WavePlayer.height}}" width="{{::WavePlayer.width}}"
                frameborder="0"
                allow="autoplay;
                fullscreen">
            </iframe>
        </div>
        </div>`
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/wavePlayer.ts